import { Disconnected, NoCamera, NoMicrophone, Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MODAL_ERROR_KEY } from '../interfaces/widgetInterface';
import { isMobile } from '../utils/device.utils';
import { IDeviceSelectorList } from './DeviceSelectorList';
import { DeviceSelectorListNative } from './DeviceSelectorListNative';
import { NoCameraMic } from './icons/NoCameraMic';

type MODAL_ERROR_VALUE = {
  ICON: JSX.Element,
};

interface IProps extends Partial<IDeviceSelectorList> {
  errorType: MODAL_ERROR_KEY;
  onDisplayPermissionSteps?: () => void;
  onReInitRecorder?: () => void;
  onRecorderRetry?: () => void;
}

const MODAL_ERRORS: { [K in MODAL_ERROR_KEY]: MODAL_ERROR_VALUE } = {
  MEDIA_PERMISSION: {
    ICON: <NoCameraMic />,
  },
  NO_SOUND: {
    ICON: <NoMicrophone />,
  },
  CONNECTION: {
    ICON: <Disconnected />,
  },
  RETRY: {
    ICON: <NoCamera />,
  },
  REDIRECT: {
    ICON: <NoCamera />,
  },
};

export const Errors:React.FC<IProps> = ({
  errorType,
  onDisplayPermissionSteps = () => {},
  onReInitRecorder = () => {},
  onRecorderRetry = () => {},
  deviceList,
  selectedDevice,
  onDeviceSelected,
  deviceType,
}) => {
  const { t } = useTranslation();
  const isNoSoundError = errorType === 'NO_SOUND';
  const cbByError: { [K in typeof errorType]: () => void } = {
    RETRY: onReInitRecorder,
    MEDIA_PERMISSION: onDisplayPermissionSteps,
    NO_SOUND: () => {},
    CONNECTION: () => {},
    REDIRECT: () => {},
  };
  return (
    <div className="myinterview-widget-errors myinterview-widget--rtl-support">
      <div className="myinterview-widget-errors__icon">
        {MODAL_ERRORS[errorType].ICON}
      </div>
      <Text className="myinterview-widget-errors__title" size="M-Bold">
        {t(`recorder.errors.${errorType}.TITLE`)}
      </Text>
      <Text className="myinterview-widget-errors__details" size="M-Regular" color="neutral-60">
        {t(
          `recorder.errors.${errorType}.DETAILS`,
          { mobile_details: isMobile ? t(`recorder.errors.${errorType}.DETAILS_MOBILE`) : '' },
        )}
      </Text>
      {(['MEDIA_PERMISSION', 'RETRY'].includes(errorType) || (isNoSoundError && isMobile)) && (
        <>
          <Text
            className="myinterview-widget-errors__cta"
            size="M-Semibold"
            color="primary"
            onClick={cbByError[errorType]}
          >
            {t(`recorder.errors.${errorType}.CTA`)}
            {isNoSoundError && deviceList && onDeviceSelected && deviceType && (
            <DeviceSelectorListNative
              deviceList={deviceList}
              selectedDevice={selectedDevice}
              onDeviceSelected={onDeviceSelected}
              deviceType="audio"
            />
            )}
          </Text>
          {errorType === 'MEDIA_PERMISSION' && (
          <Text
            className="myinterview-widget-errors__cta myinterview-widget-errors__cta--secondary"
            color="neutral-60"
            onClick={onRecorderRetry}
          >
            {t('buttons.btn_try_again').toLowerCase()}
          </Text>
          )}
        </>
      )}
    </div>
  );
};
